/* eslint-disable react/prop-types */
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SearchBar from "components/SearchBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Card, Col, Input, Label, Row, Spinner, Table } from "reactstrap";
import { weekAgo, today, formatNumber } from "redux/action/api";
import { postApi } from "redux/action/api_tbeams";

export default function MemoList({ memoType: propMemoType,buttonNew = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((e) => e.auth.user);
  const [isLoading, setIsLoading] = useState(true);
  const [memos, setMemos] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [form, setForm] = useState({ date_from: weekAgo, date_to: today });

  const params = new URLSearchParams(location.search);
  const memoType = propMemoType || params.get("type") || "All";

  const handleChanges = ({ target: { name, value } }) =>
    setForm((p) => ({ ...p, [name]: value }));

  const getMemos = useCallback(() => {
    setIsLoading(true);
    postApi("memo/list", {
      query_type: "user_memos",
      date_from: form.date_from,
      date_to: form.date_to,
      user_id: user?.username,
      role: user?.role,
      memo_type: memoType,
      status: null,
    })
      .then((data) => {
        if (data.result) setMemos(data.result);
      })
      .catch(console.log)
      .finally(() => setIsLoading(false));
  }, [form.date_from, form.date_to, user, memoType]);

  useEffect(() => {
    getMemos();
  }, [getMemos]);

  const filteredData = memos.filter(
    (item) =>
      item.mda_name?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
      item.economic_code?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  const getStatusStyle = (status) => {
    switch (status) {
      case "Approved":
        return { backgroundColor: "lightgreen" };
      case "Rejected":
        return { backgroundColor: "#ffcccc" };
      case "Pending":
        return { backgroundColor: "#fff3cd" };
      default:
        return {};
    }
  };

  const styles = { fontSize: 14 };
  const bodyStyle = (item) => ({ fontSize: 14, ...getStatusStyle(item.status) });

  return (
    <DashboardLayout>
      <MDBox pt={2} pb={3} pl={2}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h5" color="white">
                  {memoType !== "All" ? `${memoType} Memo` : "Memo List"}
                </MDTypography>
              </MDBox>
{buttonNew && (
              <Col md={4} className="mt-4">
                <button
                  className="btn btn-success"
                  style={{ marginLeft: 10 }}
                  onClick={() => navigate(`/create-memo${memoType !== "All" ? `?type=${memoType}` : ""}`)}
                >
                  Create New Memo
                </button>
              </Col>
)}
              <Row style={{ margin: 10 }}>
                <Col md={6}>
                  <Label>Search</Label>
                  <SearchBar
                    placeholder="Search by MDA or Economic Code"
                    filterText={searchQuery}
                    onFilterTextChange={(e) => setSearchQuery(e.target.value)}
                  />
                </Col>
                <Col md={3}>
                  <Label>Date From</Label>
                  <Input type="date" value={form.date_from} name="date_from" onChange={handleChanges} />
                </Col>
                <Col md={3}>
                  <Label>Date To</Label>
                  <Input type="date" value={form.date_to} name="date_to" onChange={handleChanges} />
                </Col>
              </Row>

              <div className="mt-4" style={{ width: "100%", height: 400, overflowX: "auto" }}>
                <Table bordered style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th style={styles}>Action</th>
                      <th style={styles}>Memo Date</th>
                      <th style={styles}>MDA</th>
                      <th style={styles}>Economic Code</th>
                      <th style={styles}>Program Code</th>
                      <th style={styles}>Amount</th>
                      <th style={styles}>Status</th>
                    </tr>
                  </thead>
                  {isLoading ? (
                    <tbody>
                      <tr>
                        <td colSpan={7} className="text-center">
                          <Spinner color="primary" />
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {filteredData.map((item, idx) => (
                        <tr key={idx}>
                          <td style={bodyStyle(item)}>
                            <Button
                              size="sm"
                              onClick={() => navigate(`/view-memo?id=${item.id}&memoType=${memoType}&status=${item.status}`)}
                            >
                              View
                            </Button>
                          </td>
                          <td style={bodyStyle(item)}>{item.memo_date}</td>
                          <td style={bodyStyle(item)}>{item.mda_name}</td>
                          <td style={bodyStyle(item)}>{item.economic_code}</td>
                          <td style={bodyStyle(item)}>{item.program_code}</td>
                          <td style={{ ...bodyStyle(item), textAlign: "right" }}>
                            {formatNumber(item.amount)}
                          </td>
                          <td style={bodyStyle(item)}>{item.status}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}
